const module = {
  routes: [
    {
      path: '/feedback',
      component: () => import('@/modules/feedback/pages/index.vue'),
      children: [],
      meta: {
        layout: 'default',
        requiresAuth: true
      }
    }
  ]
};

export default module;
